import { ThermometerWaterIcon } from './ThermometerWaterIcon';

/**
 * author: Michael Irigoyen
 * id 23736622-5488-4BE7-BB70-225F5F17AF2B
 * name thermometer-water
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-water.svg
 * tags
 * - Weather 
 * - Home Automation 
 */
export const WaterTemperatureIcon = ThermometerWaterIcon;
export default WaterTemperatureIcon